"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var authentication_service_1 = require("../../../shared/service/authentication.service");
var platform_browser_1 = require("@angular/platform-browser");
var file_service_1 = require("../../../shared/service/file.service");
var toast_service_1 = require("../../../shared/service/toast.service");
var ValidationComponent = /** @class */ (function () {
    function ValidationComponent(_authService, _sanitizer, _fileService, _toastService) {
        this._authService = _authService;
        this._sanitizer = _sanitizer;
        this._fileService = _fileService;
        this._toastService = _toastService;
        this.VALIDATION = 'VALIDATION';
        this.files = new Array();
        this.txOnSave = new core_1.EventEmitter();
        this.txOnCancel = new core_1.EventEmitter();
        this.authenticatedUser = this._authService.getUserFromLocalStorage();
    }
    Object.defineProperty(ValidationComponent.prototype, "attending", {
        get: function () {
            return this._attending;
        },
        set: function (attending) {
            this._attending = attending;
            this.setUpObservers();
            this.showStep();
        },
        enumerable: true,
        configurable: true
    });
    ValidationComponent.prototype.ngOnInit = function () {
    };
    ValidationComponent.prototype.ngAfterViewChecked = function () {
        try {
            Materialize.updateTextFields();
        }
        catch (e) { }
    };
    ValidationComponent.prototype.save = function () {
        var files = this.assembleCorrectFilesList();
        if (files.length > 0) {
            /**
             * On save will be called after file upload success
             * See subscribment: setUpObservers()
             */
            this.showMessage('Enviando arquivos.');
            this._fileService.saveValidationFiles(files);
        }
        else {
            this.txOnSave.emit({ attending: this.attending });
        }
    };
    ValidationComponent.prototype.cancel = function () {
        this.txOnCancel.emit();
    };
    ValidationComponent.prototype.fileChange = function (event) {
        var _this = this;
        var tempFiles = event.target.files;
        var _loop_1 = function (i) {
            var reader = new FileReader();
            reader.onload = function (otherEvent) {
                _this.files.push({ id: i, url: _this.sanitizeUrl(otherEvent.target.result), file: event.target.files[i] });
            };
            reader.readAsDataURL(event.target.files[i]);
        };
        for (var i = 0; i < tempFiles.length; i++) {
            _loop_1(i);
        }
    };
    ValidationComponent.prototype.sanitizeUrl = function (url) {
        return this._sanitizer.bypassSecurityTrustResourceUrl(url);
    };
    ValidationComponent.prototype.validationHasFiles = function () {
        try {
            return this.attending.validation.files.length > 0;
        }
        catch (e) {
            return false;
        }
    };
    ValidationComponent.prototype.changeItemValue = function (item) {
        this.attending.validation[item] = !this.attending.validation[item];
    };
    ValidationComponent.prototype.removeFileFromValidation = function (file) {
        var fileToDelete = this.attending.validation.files.find(function (f) { return f.id === file.id; });
        fileToDelete.delete = true;
    };
    ValidationComponent.prototype.removeFileFromInMemoryList = function (files, file) {
        var fileIndex = files.indexOf(file);
        files.splice(fileIndex, 1);
    };
    ValidationComponent.prototype.canEdit = function () {
        return (this.attending.validation.canEdit || this.attending.validation.canEdit === undefined) && this.editable;
    };
    ValidationComponent.prototype.canView = function () {
        return this.attending.validation.canView && !this.canEdit();
    };
    ValidationComponent.prototype.showStep = function () {
        if (this.attending.orderedSteps && this.attending.currentStep === this.VALIDATION) {
            this.setIsVisible();
            this.setIsEditable();
        }
    };
    ValidationComponent.prototype.setIsVisible = function () {
        var _this = this;
        if (this.attending.orderedSteps.includes(this.VALIDATION)
            && this.authenticatedUser.stepViews.find(function (view) { return view.stepViewType === _this.VALIDATION; })) {
            this.attending.validation.canView = true;
        }
        else {
            this.attending.dispatch.canView = false;
        }
    };
    ValidationComponent.prototype.setIsEditable = function () {
        var _this = this;
        if (this.authenticatedUser.stepKeys.find(function (view) { return view.stepType === _this.VALIDATION; })) {
            this.attending.validation.canEdit = true;
        }
        else {
            this.attending.validation.canEdit = false;
        }
    };
    ValidationComponent.prototype.assembleCorrectFilesList = function () {
        var newFiles = new Array();
        this.files.forEach(function (file) {
            newFiles.push(file.file);
        });
        return newFiles;
    };
    ValidationComponent.prototype.setUpObservers = function () {
        var _this = this;
        if (this.canEdit()) {
            this._fileService.save$
                .subscribe(function (files) {
                var attending = __assign({}, _this.attending);
                _this.files = [];
                var validationFiles = attending.validation.files || [];
                attending.validation.files = files.concat(validationFiles);
                _this.showMessage('Arquivos enviados.');
                _this.txOnSave.emit({ attending: attending });
            });
            this._fileService.error$
                .subscribe(function (error) {
                _this.files = [];
                _this.showMessage('Erro ao enviar os arquivos');
            });
        }
    };
    ValidationComponent.prototype.showMessage = function (message) {
        this._toastService.showMessage(message, 4000);
    };
    ValidationComponent.ctorParameters = function () { return [{ type: authentication_service_1.AuthenticationService }, { type: platform_browser_1.DomSanitizer }, { type: file_service_1.FileService }, { type: toast_service_1.ToastService }]; };
    return ValidationComponent;
}());
exports.ValidationComponent = ValidationComponent;
//# sourceMappingURL=validation.component.js.map


// WEBPACK FOOTER //
// validation.component.js